// extracted by mini-css-extract-plugin
module.exports = {"fullModal":"style_fullModal__nZx3y","wrapModal":"style_wrapModal__39ln6","zoomImgClose":"style_zoomImgClose__kQShE","zoomImgSpan":"style_zoomImgSpan__DcOBO"};